var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Input } from "./Input";
import { PhoneNumberUse } from "./admin-gql";
import { SelectPhoneUse } from "./SelectPhoneUse";
import { createValidator, validatePhoneNumberAsync, validatePhoneNumberSync } from "./validation";
import { debounceTimeInMs } from "./constants";
import i18next from "i18next";
var PhoneNumberControl = /** @class */ (function (_super) {
    __extends(PhoneNumberControl, _super);
    function PhoneNumberControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validator = createValidator(debounceTimeInMs);
        return _this;
    }
    PhoneNumberControl.prototype.render = function () {
        var props = this.props;
        return (React.createElement(PhoneNumberInputControl, __assign({}, props, { value: props.phoneNumber, onRemove: function () { return props.onRemove(props.phoneNumber); } })));
    };
    PhoneNumberControl.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.phoneNumber.value !== this.props.phoneNumber.value) {
            this.validate();
        }
    };
    PhoneNumberControl.prototype.validate = function () {
        var _this = this;
        this.validator(function () { return validatePhoneNumberSync(_this.props.phoneNumber.value); }, function () { return validatePhoneNumberAsync(_this.props.phoneNumber.value, _this.props.client); }, function (promise, result) {
            _this.props.onChange(__assign(__assign({}, _this.props.phoneNumber), { validationError: result, validationPromise: promise }));
        });
    };
    return PhoneNumberControl;
}(React.Component));
export { PhoneNumberControl };
export var PhoneNumberInputControl = function (props) {
    var commonProps = {
        disabled: props.disabled,
        forceShowValidationError: props.touched,
        readonly: props.readonly,
        loading: props.loading
    };
    var checkboxId = React.useState(Math.random().toString())[0];
    return (React.createElement("div", { className: props.className },
        React.createElement("div", { className: "form-row" },
            React.createElement("div", { className: "col-6 form-group" },
                React.createElement(Input, __assign({ onChange: function (newStr) { return props.onChange(__assign(__assign({}, props.value), { value: newStr })); }, validationErrorMessage: props.error || undefined, value: props.value.value, placeholder: i18next.t("cc.phone.number.control.phoneNumber"), autoFocus: props.autoFocus }, commonProps)),
                React.createElement("div", { className: "form-check mt-2" },
                    React.createElement("input", { type: "checkbox", className: "form-check-input", id: checkboxId, checked: props.value.canBeUsedForSmsCodes === undefined ||
                            props.value.canBeUsedForSmsCodes === null
                            ? true
                            : props.value.canBeUsedForSmsCodes, disabled: props.disabled || props.readonly, readOnly: props.readonly, onChange: function (ev) {
                            return props.onChange(__assign(__assign({}, props.value), { canBeUsedForSmsCodes: ev.target.checked }));
                        } }),
                    React.createElement("label", { className: "form-check-label", htmlFor: checkboxId }, i18next.t("cc.phone.number.control.smsLogin")))),
            React.createElement("div", { className: "col-6 form-group" },
                React.createElement(SelectPhoneUse, __assign({ readonly: props.readonly, use: props.value.use || PhoneNumberUse.PRIVATE, onChange: function (newUse) { return props.onChange(__assign(__assign({}, props.value), { use: newUse })); } }, commonProps)),
                !props.readonly ? (React.createElement("div", { className: "text-right mt-1" },
                    React.createElement("button", { className: "btn btn-link p-0", onClick: function () { return props.onRemove(); } }, i18next.t("cc.phone.number.control.remove")))) : null))));
};
//# sourceMappingURL=PhoneNumberControl.js.map